/**
 * Yadom Label Editor — Tokyo Messy
 * Canvas-based simple label designer for cap + body labels.
 */
(function () {
  'use strict';

  var HANDLE_SIZE = 12;

  var state = {
    cap: { canvas: null, ctx: null, bgColor: '#FFFFFF', objects: [], selectedIndex: -1, w: 479, h: 479 },
    body: { canvas: null, ctx: null, bgColor: '#FFFFFF', objects: [], selectedIndex: -1, w: 1700, h: 434 }
  };
  var activeLabel = 'cap';
  var dragInfo = null; // { index, offsetX, offsetY, type: 'move'|'resize', handle }

  function getActive() { return state[activeLabel]; }

  // ---- Init ----
  function init() {
    state.cap.canvas = document.getElementById('yle-canvas-cap');
    state.body.canvas = document.getElementById('yle-canvas-body');
    if (!state.cap.canvas || !state.body.canvas) return;
    state.cap.ctx = state.cap.canvas.getContext('2d');
    state.body.ctx = state.body.canvas.getContext('2d');

    render(state.cap);
    render(state.body);

    // Label switch (cap/body)
    var labelTabs = document.querySelectorAll('.yle__label-tab');
    labelTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        labelTabs.forEach(function (t) { t.classList.remove('yle__label-tab--active'); });
        tab.classList.add('yle__label-tab--active');
        activeLabel = tab.dataset.target;
        document.getElementById('yle-area-cap').style.display = activeLabel === 'cap' ? '' : 'none';
        document.getElementById('yle-area-body').style.display = activeLabel === 'body' ? '' : 'none';
        updateSelectionTools();
      });
    });

    // Background color
    var swatches = document.querySelectorAll('#yle-bg-colors .yle__swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('yle__swatch--active'); });
        sw.classList.add('yle__swatch--active');
        getActive().bgColor = sw.dataset.color;
        render(getActive());
      });
    });
    var customColor = document.getElementById('yle-bg-custom');
    if (customColor) {
      customColor.addEventListener('input', function () {
        swatches.forEach(function (s) { s.classList.remove('yle__swatch--active'); });
        getActive().bgColor = customColor.value;
        render(getActive());
      });
    }

    // Add text
    var addTextBtn = document.getElementById('yle-add-text');
    if (addTextBtn) {
      addTextBtn.addEventListener('click', function () {
        var text = document.getElementById('yle-text-input').value.trim();
        if (!text) return;
        var font = document.getElementById('yle-font-select').value;
        var color = document.getElementById('yle-text-color').value;
        var size = parseInt(document.getElementById('yle-text-size').value, 10);
        addText(getActive(), text, font, size, color);
        document.getElementById('yle-text-input').value = '';
      });
    }

    // Add image
    var addImgBtn = document.getElementById('yle-add-image');
    var imgInput = document.getElementById('yle-image-input');
    if (addImgBtn && imgInput) {
      addImgBtn.addEventListener('click', function () { imgInput.click(); });
      imgInput.addEventListener('change', function () {
        if (!imgInput.files.length) return;
        var reader = new FileReader();
        reader.onload = function (e) {
          var img = new Image();
          img.onload = function () { addImage(getActive(), img); };
          img.src = e.target.result;
        };
        reader.readAsDataURL(imgInput.files[0]);
        imgInput.value = '';
      });
    }

    // Selection tools
    var deleteBtn = document.getElementById('yle-delete');
    var frontBtn = document.getElementById('yle-bring-front');
    var backBtn = document.getElementById('yle-send-back');
    if (deleteBtn) deleteBtn.addEventListener('click', function () { deleteSelected(getActive()); });
    if (frontBtn) frontBtn.addEventListener('click', function () { reorder(getActive(), 1); });
    if (backBtn) backBtn.addEventListener('click', function () { reorder(getActive(), -1); });

    // Canvas mouse events
    setupCanvasEvents(state.cap);
    setupCanvasEvents(state.body);
  }

  // ---- Canvas Events ----
  function setupCanvasEvents(s) {
    var canvas = s.canvas;

    function getPos(e) {
      var touch = e.touches ? e.touches[0] : e;
      var rect = canvas.getBoundingClientRect();
      return {
        x: (touch.clientX - rect.left) * (s.w / rect.width),
        y: (touch.clientY - rect.top) * (s.h / rect.height)
      };
    }

    function onDown(e) {
      var pos = getPos(e);
      // Check resize handle first
      if (s.selectedIndex >= 0) {
        var handle = getResizeHandle(s.objects[s.selectedIndex], pos.x, pos.y);
        if (handle) {
          dragInfo = { index: s.selectedIndex, type: 'resize', handle: handle, startX: pos.x, startY: pos.y, origObj: Object.assign({}, s.objects[s.selectedIndex]) };
          e.preventDefault();
          return;
        }
      }
      // Hit test
      var idx = hitTest(s, pos.x, pos.y);
      s.selectedIndex = idx;
      updateSelectionTools();
      if (idx >= 0) {
        var obj = s.objects[idx];
        dragInfo = { index: idx, type: 'move', offsetX: pos.x - obj.x, offsetY: pos.y - obj.y };
        e.preventDefault();
      }
      render(s);
    }

    function onMove(e) {
      if (!dragInfo) return;
      var pos = getPos(e);
      var obj = s.objects[dragInfo.index];
      if (dragInfo.type === 'move') {
        obj.x = pos.x - dragInfo.offsetX;
        obj.y = pos.y - dragInfo.offsetY;
      } else if (dragInfo.type === 'resize') {
        var dx = pos.x - dragInfo.startX;
        var dy = pos.y - dragInfo.startY;
        var orig = dragInfo.origObj;
        var aspect = orig.width / orig.height;
        var delta = Math.abs(dx) > Math.abs(dy) ? dx : dy * aspect;
        if (dragInfo.handle === 'br' || dragInfo.handle === 'tr') {
          obj.width = Math.max(20, orig.width + delta);
        } else {
          obj.width = Math.max(20, orig.width - delta);
          obj.x = orig.x + (orig.width - obj.width);
        }
        obj.height = obj.width / aspect;
        if (dragInfo.handle === 'tr' || dragInfo.handle === 'tl') {
          obj.y = orig.y + (orig.height - obj.height);
        }
      }
      render(s);
      e.preventDefault();
    }

    function onUp() {
      dragInfo = null;
    }

    canvas.addEventListener('mousedown', onDown);
    canvas.addEventListener('mousemove', onMove);
    canvas.addEventListener('mouseup', onUp);
    canvas.addEventListener('mouseleave', onUp);
    canvas.addEventListener('touchstart', onDown, { passive: false });
    canvas.addEventListener('touchmove', onMove, { passive: false });
    canvas.addEventListener('touchend', onUp);
  }

  // ---- Render ----
  function render(s) {
    var ctx = s.ctx;
    // Background
    ctx.fillStyle = s.bgColor;
    ctx.fillRect(0, 0, s.w, s.h);
    // Objects
    for (var i = 0; i < s.objects.length; i++) {
      drawObject(ctx, s.objects[i]);
    }
    // Selection
    if (s.selectedIndex >= 0 && s.selectedIndex < s.objects.length) {
      drawSelection(ctx, s.objects[s.selectedIndex]);
    }
  }

  function drawObject(ctx, obj) {
    if (obj.type === 'text') {
      ctx.font = obj.fontSize + 'px ' + obj.font;
      ctx.fillStyle = obj.color;
      ctx.textBaseline = 'top';
      ctx.fillText(obj.text, obj.x, obj.y);
    } else if (obj.type === 'image') {
      ctx.drawImage(obj.img, obj.x, obj.y, obj.width, obj.height);
    }
  }

  function drawSelection(ctx, obj) {
    var x = obj.x - 2;
    var y = obj.y - 2;
    var w = obj.width + 4;
    var h = obj.height + 4;
    ctx.strokeStyle = '#0066FF';
    ctx.lineWidth = 2;
    ctx.setLineDash([6, 3]);
    ctx.strokeRect(x, y, w, h);
    ctx.setLineDash([]);
    // Handles
    var hs = HANDLE_SIZE;
    ctx.fillStyle = '#0066FF';
    ctx.fillRect(x - hs / 2, y - hs / 2, hs, hs);
    ctx.fillRect(x + w - hs / 2, y - hs / 2, hs, hs);
    ctx.fillRect(x - hs / 2, y + h - hs / 2, hs, hs);
    ctx.fillRect(x + w - hs / 2, y + h - hs / 2, hs, hs);
  }

  // ---- Hit Test ----
  function hitTest(s, x, y) {
    for (var i = s.objects.length - 1; i >= 0; i--) {
      var obj = s.objects[i];
      if (x >= obj.x && x <= obj.x + obj.width && y >= obj.y && y <= obj.y + obj.height) {
        return i;
      }
    }
    return -1;
  }

  function getResizeHandle(obj, x, y) {
    var hs = HANDLE_SIZE + 4;
    var ox = obj.x - 2;
    var oy = obj.y - 2;
    var ow = obj.width + 4;
    var oh = obj.height + 4;
    if (dist(x, y, ox, oy) < hs) return 'tl';
    if (dist(x, y, ox + ow, oy) < hs) return 'tr';
    if (dist(x, y, ox, oy + oh) < hs) return 'bl';
    if (dist(x, y, ox + ow, oy + oh) < hs) return 'br';
    return null;
  }

  function dist(x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
  }

  // ---- Add Objects ----
  function addText(s, text, font, fontSize, color) {
    var ctx = s.ctx;
    ctx.font = fontSize + 'px ' + font;
    var metrics = ctx.measureText(text);
    var w = metrics.width;
    var h = fontSize * 1.2;
    s.objects.push({
      type: 'text', text: text, font: font, fontSize: fontSize, color: color,
      x: (s.w - w) / 2, y: (s.h - h) / 2, width: w, height: h
    });
    s.selectedIndex = s.objects.length - 1;
    updateSelectionTools();
    render(s);
  }

  function addImage(s, img) {
    var maxW = s.w * 0.5;
    var maxH = s.h * 0.5;
    var scale = Math.min(maxW / img.width, maxH / img.height, 1);
    var w = img.width * scale;
    var h = img.height * scale;
    s.objects.push({
      type: 'image', img: img,
      x: (s.w - w) / 2, y: (s.h - h) / 2, width: w, height: h
    });
    s.selectedIndex = s.objects.length - 1;
    updateSelectionTools();
    render(s);
  }

  // ---- Object Operations ----
  function deleteSelected(s) {
    if (s.selectedIndex < 0) return;
    s.objects.splice(s.selectedIndex, 1);
    s.selectedIndex = -1;
    updateSelectionTools();
    render(s);
  }

  function reorder(s, dir) {
    var i = s.selectedIndex;
    if (i < 0) return;
    var newI = i + dir;
    if (newI < 0 || newI >= s.objects.length) return;
    var tmp = s.objects[i];
    s.objects[i] = s.objects[newI];
    s.objects[newI] = tmp;
    s.selectedIndex = newI;
    render(s);
  }

  function updateSelectionTools() {
    var tools = document.getElementById('yle-selection-tools');
    if (tools) {
      tools.style.display = getActive().selectedIndex >= 0 ? '' : 'none';
    }
  }

  // ---- Export ----
  function exportCanvas(s) {
    if (s.objects.length === 0) return Promise.resolve(null);
    var saved = s.selectedIndex;
    s.selectedIndex = -1;
    render(s);
    return new Promise(function (resolve) {
      s.canvas.toBlob(function (blob) {
        s.selectedIndex = saved;
        render(s);
        resolve(blob);
      }, 'image/png');
    });
  }

  function exportBoth() {
    return Promise.all([exportCanvas(state.cap), exportCanvas(state.body)]).then(function (blobs) {
      return {
        cap: blobs[0] ? new File([blobs[0]], 'cap-design.png', { type: 'image/png' }) : null,
        body: blobs[1] ? new File([blobs[1]], 'body-design.png', { type: 'image/png' }) : null
      };
    });
  }

  // ---- Public API ----
  window.YadomLabelEditor = {
    exportBoth: exportBoth
  };

  // ---- Boot ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
